import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Step, { iconClassAndTextForStep } from './step';
import GatesProgressStepper from './stepper';

function GatesProgressBar({
  caSigned,
  compact,
  lead,
  leadInfo,
  leaseBrokerVaultSteps,
  leaseGrayedOut,
  leaseOwnerVaultSteps,
  saleBrokerVaultSteps,
  saleGrayedOut,
  saleOrLease,
  saleOwnerVaultSteps,
  showSaleOrLease,
  useVaultGates,
  userType
}) {
  let steps;
  let leadAccessLevel = '';
  let grayedOut;

  if (saleOrLease === 'Sale') {
    steps = userType === 'broker' ? saleBrokerVaultSteps : saleOwnerVaultSteps;
    if (useVaultGates) {
      leadAccessLevel = lead.saleVaultGatesAccessLevel;
    } else {
      leadAccessLevel = lead.docAccessLevelForSale;
    }
    grayedOut = saleGrayedOut;
  } else {
    steps = userType === 'broker' ? leaseBrokerVaultSteps : leaseOwnerVaultSteps;
    if (useVaultGates) {
      leadAccessLevel = lead.leaseVaultGatesAccessLevel;
    } else {
      leadAccessLevel = lead.docAccessLevelForLease;
    }
    grayedOut = leaseGrayedOut;
  }

  if (compact) {
    const stages = steps.map((step) => {
      const { boxText, iconClassName } = iconClassAndTextForStep({
        leadAccessLevel,
        profileComplete: !leadInfo.profileNotComplete,
        signed: caSigned,
        step,
        useVaultGates,
        verified: !leadInfo.accountNotVerified,
        waitlistApproved: leadInfo.waitlistApproved
      });

      return { done: iconClassName !== 'not-completed', label: boxText, step };
    });

    return (
      <div style={{ opacity: grayedOut ? 0.5 : 1 }}>
        {showSaleOrLease && <h6 className="mb-1">For {saleOrLease}</h6>}
        <GatesProgressStepper saleOrLease={saleOrLease} stages={stages} />
      </div>
    );
  }

  return (
    <React.Fragment>
      <div style={{ opacity: grayedOut ? 0.5 : 1 }}>
        {showSaleOrLease && <h6 className="mb-1">For {saleOrLease}</h6>}
        <div className="lead-gates-progress-bar">
          {steps.map(step => (
            <Step
              key={step}
              leadAccessLevel={leadAccessLevel}
              profileComplete={!leadInfo.profileNotComplete}
              signed={caSigned}
              step={step}
              useVaultGates={useVaultGates}
              verified={!leadInfo.accountNotVerified}
              waitlistApproved={leadInfo.waitlistApproved}
            />
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

GatesProgressBar.propTypes = {
  caSigned: PropTypes.bool.isRequired,
  compact: PropTypes.bool,
  lead: PropTypes.object.isRequired,
  leadInfo: PropTypes.shape({
    accountNotVerified: PropTypes.bool.isRequired,
    caNotSigned: PropTypes.bool.isRequired,
    profileNotComplete: PropTypes.bool.isRequired,
    waitlistApproved: PropTypes.bool.isRequired
  }).isRequired,
  leaseBrokerVaultSteps: PropTypes.array,
  leaseGrayedOut: PropTypes.bool,
  leaseOwnerVaultSteps: PropTypes.array,
  saleBrokerVaultSteps: PropTypes.array,
  saleGrayedOut: PropTypes.bool,
  saleOrLease: PropTypes.oneOf(['Sale', 'Lease']),
  saleOwnerVaultSteps: PropTypes.array,
  showSaleOrLease: PropTypes.bool.isRequired,
  userType: PropTypes.string,
  useVaultGates: PropTypes.bool.isRequired
};

const mapStateToProps = ({ project }) => ({
  useVaultGates: project.useVaultGates,
  saleBrokerVaultSteps: project.saleVault?.brokerVaultSteps,
  saleOwnerVaultSteps: project.saleVault?.ownerVaultSteps,
  saleGrayedOut: !project.saleChecked,
  leaseBrokerVaultSteps: project.leaseVault?.brokerVaultSteps,
  leaseOwnerVaultSteps: project.leaseVault?.ownerVaultSteps,
  leaseGrayedOut: !project.leaseChecked
});

export default connect(mapStateToProps)(GatesProgressBar);
